import UserProfile from "../Context/UserProfile";
import { useEffect, useState } from "react";
const FAQs = ({ setUserName,setPageTitle }) => {
	const [displayName, setDisplayName] = useState();
	useEffect(() => {
		setUserName(UserProfile.getName());
        setDisplayName(UserProfile.getName());
        if(UserProfile.getLoginStatus()==="1"){
			setPageTitle("Frequently Asked Questions");
		}
	}, [])
	return (
		<>
			<div className={displayName && displayName.length > 0 ? "main-content" : ""}>
				{UserProfile.getLoginStatus()!=="1" && <><header>
				<div className="header-container">
					<div className="logo">
						<a style={{ textDecoration: "none" }} href="/">
							<span style={{ color: 'white' }}>Contr
								<span style={{ color: "#ff8400" }}>e</span>
								ct</span>
						</a>

					</div>
					<nav><a href="/Signup" className="btn btn-success">Sign In</a>
					</nav>
				</div>
			</header>
			<div style={{ paddingTop: '20px', paddingLeft: '20px' }}>
				<h1>Frequently Asked Questions</h1>
				<span className="effective-date">Last Updated: 3 December 2025</span>
			</div></>}

				<div style={{ marginTop: "5px", textAlign: "left", padding: "40px", maxHeight: "100%", overflowX: "scroll" }}>
					
    <details>
      <summary>What is Contrect?</summary>
      <p>
        Contrect is an AI-powered agreement platform that helps you create, review,
        and execute contracts. It focuses on making sure agreements are not just drafted,
        but actually followed and completed.
      </p>
    </details>

    <details>
      <summary>Is Contrect a legal advice app?</summary>
      <p>
        No. Contrect does not provide legal advice. It helps generate structured agreements
        using commonly accepted legal language and business norms for India.
        For complex or high-value matters, you should consult a qualified lawyer.
      </p>
    </details>

    <details>
      <summary>How does AI help in creating contracts?</summary>
      <p>
        Contrect uses AI to ask simple, guided questions and generate a professionally
        written contract based on your inputs. This reduces manual effort and avoids
        common mistakes.
      </p>
    </details>

    <details>
      <summary>Can I edit the contract after it is generated?</summary>
      <p>
        Yes. You can review and edit clauses before sharing the agreement with the other party.
        Once the agreement is sent for review, editing may be restricted until the review is completed.
      </p>
    </details>

    <details>
      <summary>Does Contrect support PDF generation?</summary>
      <p>
        Yes. You can generate a clean, professional PDF version of your agreement
        for offline sharing or record keeping.
      </p>
    </details>

    <details>
      <summary>Is Contrect free to use?</summary>
      <p>
        Contrect is currently available in early access and is free to use.
        Pricing may be introduced later as the product evolves.
      </p>
    </details>

    <details>
      <summary>Is Contrect suitable for India?</summary>
      <p>
        Yes. Contrect is built with India-first legal phrasing and commonly used
        Indian business practices in mind.
      </p>
    </details>
	<details>
  <summary>How can I contact Contrect for support or queries?</summary>
  <p>
    If you have any questions, issues, or need assistance, you can contact us by
    sending an email to our support team. We will review your query and respond
    as soon as possible.
    <br /><br />
    <strong>Email:</strong> arpandeepesh@gmail.com
  </p>
</details>

<details>
  <summary>How can I request account deletion or data removal?</summary>
  <p>
    If you wish to delete your account or request removal of your personal data
    that cannot be deleted directly from the application, you can send us an
    email request.
    <br /><br />
    Please email us from your registered email address or mention your registered
    mobile number so we can verify your request.
    <br /><br />
    <strong>Email:</strong> arpandeepesh@gmail.com
  </p>
</details>


				</div>
			</div>
			
		</>
	);
};
export default FAQs;